import { HttpBackend } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CfgService } from '../../../../cfg/cfg.service';
import { ServerAddressesCfgService } from 'src/app/util/serverAddressesCfg.service';

export class BucketStatusCfg {
  public summaryEndpointPattern: string;
  public detailEndpointPattern: string;
}

export class BucketStatusKpiCfg {
  public bucketStatus: BucketStatusCfg;
}

@Injectable()
export class BucketStatusKpiCfgService extends CfgService<BucketStatusKpiCfg> {
  json: any = {
    bucketStatus: {
      summaryEndpointPattern: "%{DashboardApiUrl}/bucketgoal/{0}",
      detailEndpointPattern: "%{TalentApiUrl}/#/candidates?tab=buckets&branchId={0}"
    }
  }

  constructor(httpBackend: HttpBackend, private serverAddressesCfgService: ServerAddressesCfgService) {
    super(httpBackend);
  }

  protected getCfgFile(): string {
    return `/cfg/kpi/bucketStatusKpi.cfg.json`;
  }

  /**
* Carga las url en el json
*/
  loadDataUrl() {
    this.replacePlaceholders(this.json, this.serverAddressesCfgService.getData());
  }
}
